import * as React from "react";
import { Radio, RadioGroupProps } from "antd";
import { formSet, formSetValue, useCpFormValue } from "./utils";
import { store } from "../../../store";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props extends Omit<RadioGroupProps, "id" | "name" | "value" | "status"> {
  name: string;
  vertical?: boolean;
}
export const CpRadioGroup = (props: Props): React.ReactElement => {
  const { id } = useCpFormContext();
  const { vertical, className, name, onFocus, onBlur, onChange, ...radioGroupProps } = props;

  const value = useCpFormValue(name);

  const fieldStatePath = React.useMemo(() => `fieldStates.${name}`, [name]);

  return (
    <Radio.Group
      {...radioGroupProps}
      id={name}
      value={value}
      className={`${vertical ? "flex flex-col" : ""} ${className}`}
      onChange={(e) => {
        onChange?.(e);
        formSetValue(id, name, e.target.value);
        formSet(id, `${fieldStatePath}.modified`, true);
        const form = store.getState().form.instances[id];
        const onChangeCounter = form.meta.onChangeCounter;
        formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);
      }}
      onFocus={(e) => {
        onFocus?.(e);
        formSet(id, `${fieldStatePath}.focused`, true);
        formSet(id, `${fieldStatePath}.visited`, true);
      }}
      onBlur={(e) => {
        onBlur?.(e);
        formSet(id, `${fieldStatePath}.focused`, false);
        formSet(id, `${fieldStatePath}.touched`, true);
        const form = store.getState().form.instances[id];
        const onBlurCounter = form.meta.onBlurCounter;
        formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
      }}
    />
  );
};
